import {PersonResource, PersonsService} from "../../core/modules/openapi";
import {DataSource} from "@angular/cdk/collections";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {EventEmitter, signal} from "@angular/core";
import {catchError, merge, Observable, of as observableOf, switchMap} from "rxjs";
import {map, startWith} from "rxjs/operators";

export interface TableItem extends PersonResource {
}

export class PersonsFilter {
  firstName: string;
  lastName: string;
  clientId: string;
  updated: EventEmitter<any> = new EventEmitter();
}

export class PersonsTableDataSource extends DataSource<TableItem> {
  data: TableItem[] = [];
  paginator: MatPaginator | undefined;
  sort: MatSort | undefined;
  filter: PersonsFilter | undefined;

  resultsLength = signal(0);
  isLoadingResults = signal(false);

  constructor(private readonly personsService: PersonsService) {
    super();
  }

  /**
   * Connect this data source to the table. The table will only update when
   * the returned stream emits new items.
   * @returns A stream of the items to be rendered.
   */
  connect(): Observable<TableItem[]> {
    if (this.paginator && this.sort && this.filter) {
      // Combine everything that affects the rendered data into one update
      // stream for the data-table to consume.
      return merge(this.paginator.page, this.sort.sortChange, this.filter.updated)
      .pipe(
        startWith({}),
        switchMap(() => {
          const sortStr = this.sort!.active + "," + this.sort!.direction;
          if (this.filter?.firstName || this.filter?.lastName || this.filter?.clientId) {
            this.isLoadingResults.set(true);
            return this.personsService.getPersons(this.filter.clientId, this.filter.firstName, this.filter.lastName, "es", this.paginator!.pageIndex,
              ['name,asc'], this.paginator!.pageSize).pipe(
              catchError(() => observableOf({content: [], totalElements: 0})),
              map((data) => {
                // Flip flag to show that loading has finished.
                this.isLoadingResults.set(false);
                this.resultsLength.set(data.totalElements!);
                return data.content as TableItem[];
              })
            );
          } else {
            this.isLoadingResults.set(false);
            return [];
          }
        })
      );
    } else {
      throw Error(
        'Please set the paginator, sort and database on the data source before connecting.'
      );
    }
  }

  /**
   *  Called when the table is being destroyed. Use this function, to clean up
   * any open connections or free any held resources that were set up during connect.
   */
  disconnect(): void {
  }
}
